import { ThemeOptions } from '@mui/material/styles';

/** Verde, amarelo e azul da bandeira — inspirado no dashboard Copa 2026 */
export const copaPaletteOptions: ThemeOptions['palette'] = {
  mode: 'light',
  primary: {
    main: '#013f1e',
    light: '#026b34',
    dark: '#012a15',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#FFCC00',
    light: '#ffe066',
    dark: '#e6b800',
    contrastText: '#1a3328',
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
  },
  warning: {
    main: '#f59e0b',
    light: '#fbbf24',
    dark: '#d97706',
  },
  info: {
    main: '#0052B4',
    light: '#2563eb',
    dark: '#003d82',
  },
  success: {
    main: '#013f1e',
    light: '#026b34',
    dark: '#012a15',
  },
  background: {
    default: '#f0f5f2',
    paper: '#ffffff',
  },
  text: {
    primary: '#1a3328',
    secondary: '#4a6358',
    disabled: '#8fa89a',
  },
  divider: 'rgba(0, 107, 45, 0.12)',
  action: {
    active: '#4a6358',
    hover: 'rgba(0, 151, 57, 0.08)',
    selected: 'rgba(255, 204, 0, 0.22)',
    disabled: 'rgba(74, 99, 88, 0.38)',
    disabledBackground: 'rgba(74, 99, 88, 0.12)',
  },
  grey: {
    50: '#f8faf9',
    100: '#eef3f0',
    200: '#dde8e2',
    300: '#c5d4cb',
    400: '#8fa89a',
    500: '#6b8578',
    600: '#4a6358',
    700: '#334a40',
    800: '#1a3328',
    900: '#0d1f17',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
  },
  gradient: {
    primary: 'linear-gradient(135deg, #012a15 0%, #013f1e 50%, #026b34 100%)',
    secondary: 'linear-gradient(135deg, #e6b800 0%, #FFCC00 50%, #ffe066 100%)',
  },
};

export const copaComponentOverrides: ThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        scrollbarColor: '#c5d4cb transparent',
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: '#013f1e',
        backgroundImage: 'none',
        color: '#ffffff',
        overflowY: 'hidden',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        backgroundColor: '#ffffff',
        color: '#1a3328',
        boxShadow: '0 2px 16px rgba(0, 60, 36, 0.1)',
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        border: '1px solid rgba(0, 107, 45, 0.1)',
        boxShadow: '0 4px 20px rgba(0, 60, 36, 0.08)',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderColor: 'rgba(0, 107, 45, 0.1)',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 107, 45, 0.22)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 151, 57, 0.45)',
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      containedPrimary: {
        boxShadow: '0 4px 14px rgba(0, 151, 57, 0.35)',
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      colorPrimary: {
        backgroundColor: 'rgba(0, 151, 57, 0.12)',
        color: '#013f1e',
      },
    },
  },
};
